import { useState } from "react";
import { Button } from "./Button";

export function CopyButton({ value, label = "COPY" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  return (
    <Button
      variant="ghost"
      onClick={async () => {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 500);
      }}
    >
      {copied ? "COPIED" : label}
    </Button>
  );
}
